export const localApiUrl = process.env.REACT_APP_LOCAL_API_URL
export const apiUrl = process.env.REACT_APP_API_URL
